export enum ELineSeparator {
    DESKTOP = '{%desktop_break%}',
    MOBILE = '{%mobile_break%}',
}